export default __webpack_public_path__ + "static/media/logo-windows.a6a7b084.svg";